// Game-wide constants. Living in their own module so scenes can import
// them without dragging in main.ts (which would create a circular import).

export const GAME_WIDTH = 480;
export const GAME_HEIGHT = 270;

// Pixel webfonts loaded from Google Fonts (see index.html). These render
// much cleaner than the OS monospace fallback against the pixelArt scale.
//   FONT_DISPLAY — chunky retro for headings, banners, big score
//   FONT_BODY    — clean pixel monospace for body, HUD, hints
export const FONT_DISPLAY = '"Press Start 2P", monospace';
export const FONT_BODY = '"VT323", "Press Start 2P", monospace';
